import { Component, OnInit } from '@angular/core';
import { ApiRequestsService } from 'src/app/services/api-requests.service';
import { DataManipulateService } from 'src/app/services/data-manipulate.service';

@Component({
  selector: 'app-default-sidebar',
  templateUrl: './default-sidebar.component.html',
  styleUrls: ['./default-sidebar.component.scss']
})
export class DefaultSidebarComponent implements OnInit {

  tempvariable:boolean=false;
  userRole:string = '';

  constructor(private data:DataManipulateService, private api:ApiRequestsService){}
  ngOnInit(): void {
    this.userRole = this.data.userInfo['userrole'];
    console.log(this.api.Token);
    
  }

  togglemini() {
    document.body.classList.toggle('sidebar-mini');
  }
  
}
